import LegalLayout from "./LegalLayout";

export default function AGBPage() {
  return (
    <LegalLayout title="Allgemeine Geschäftsbedingungen" kicker="AGB">
      <h2>1. Geltungsbereich</h2>
      <p>
        Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen
        <strong> Eljhat Kadrii e.U.</strong> (im Folgenden &bdquo;Haus des Handys&ldquo;),
        Hernalser Hauptstraße 135, 1170 Wien,
        und dem Kunden über die Reparatur von Mobilgeräten sowie den Verkauf von Zubehör über
        diese Website und im Geschäftslokal.
      </p>

      <h2>2. Vertragsabschluss</h2>
      <p>
        Die Darstellung der Produkte und Dienstleistungen stellt kein verbindliches Angebot dar. Mit dem Klick
        auf &bdquo;Sicher bezahlen&ldquo; geben Sie eine verbindliche Bestellung ab. Der Kaufvertrag kommt mit Annahme
        durch uns (Bestätigungsmail oder Versand) zustande.
      </p>

      <h2>3. Preise & Zahlung</h2>
      <p>
        Alle angegebenen Preise sind <strong>Bruttopreise inkl. 20% österreichischer Umsatzsteuer</strong>.
        Reparaturpreise auf dieser Website verstehen sich als <em>&bdquo;ab Preis&ldquo;</em> – der endgültige Preis kann
        sich nach Eingangsprüfung des Geräts ändern und wird vor Beginn der Reparatur mit Ihnen abgestimmt.
      </p>
      <p>Akzeptierte Zahlungsmethoden:</p>
      <ul>
        <li>Kredit-/Debitkarte (Visa, Mastercard, AmEx) via Stripe</li>
        <li>Apple Pay / Google Pay</li>
        <li>Klarna Ratenzahlung (sofern aktiviert)</li>
        <li>Santander Ratenkauf (auf Anfrage)</li>
        <li>Barzahlung im Geschäft</li>
      </ul>

      <h2>4. Versand & Lieferung</h2>
      <ul>
        <li>Standard Versand: 4,90 € · 2–3 Werktage innerhalb Österreichs</li>
        <li>Express Versand: 9,90 € · nächster Werktag</li>
        <li>Selbstabholung im Geschäft: kostenlos</li>
      </ul>
      <p>Lieferungen ins Ausland nach Absprache.</p>

      <h2>5. Reparaturauftrag</h2>
      <p>
        Bei Übergabe Ihres Geräts wird ein Reparaturauftrag erstellt. Der Endpreis basiert auf der Diagnose
        und wird vor Beginn der Arbeiten mit Ihnen abgestimmt. Datenrettung und -sicherung obliegen dem
        Kunden — wir empfehlen vor der Übergabe ein Backup. Eine Haftung für Datenverlust ist ausgeschlossen.
      </p>

      <h2>6. Garantie</h2>
      <ul>
        <li>6 Monate Garantie auf alle ausgetauschten Originalteile und durchgeführten Reparaturen</li>
        <li>2 Jahre gesetzliche Gewährleistung auf gekaufte Neuware</li>
        <li>Garantie ausgeschlossen bei Folgeschäden durch Sturz, Wasser oder unsachgemäße Handhabung</li>
      </ul>

      <h2>7. Widerrufsrecht (für Verbraucher)</h2>
      <p>
        Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen den Vertrag zu widerrufen. Die Widerrufsfrist
        beginnt mit dem Tag, an dem Sie oder ein von Ihnen benannter Dritter die Ware in Besitz genommen haben.
      </p>
      <p>
        Zur Ausübung des Widerrufsrechts senden Sie eine eindeutige Erklärung (Brief, E-Mail) an:<br />
        <strong>Eljhat Kadrii e.U.</strong>, Hernalser Hauptstraße 135, 1170 Wien<br />
        E-Mail: <a href="mailto:store@hausdeshandys.at">store@hausdeshandys.at</a>
      </p>
      <p>
        <em>Ausnahmen:</em> Das Widerrufsrecht besteht nicht bei bereits begonnenen Reparaturdienstleistungen
        sowie bei versiegelten Hygieneartikeln (z. B. In-Ear-Kopfhörer), deren Versiegelung nach Lieferung
        entfernt wurde.
      </p>

      <h2>8. Eigentumsvorbehalt</h2>
      <p>Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.</p>

      <h2>9. Haftung</h2>
      <p>
        Wir haften unbeschränkt für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit haften wir
        nur bei Verletzung wesentlicher Vertragspflichten in Höhe des vorhersehbaren Schadens.
      </p>

      <h2>10. Schlussbestimmungen</h2>
      <p>
        Es gilt österreichisches Recht. Gerichtsstand für Streitigkeiten ist Wien, soweit nicht zwingende
        Verbraucherschutzbestimmungen entgegenstehen.
      </p>

      <p className="text-xs text-zinc-600 mt-12">
        Stand: Februar 2026. Eljhat Kadrii e.U. · FN 628945w · UID ATU81376119
      </p>
    </LegalLayout>
  );
}
